module.exports = __webpack_public_path__ + "assets/img/car12.a42a8668.jpg";